import { createContext } from "react";

import {
  IRemoteDataContext,
  IViewDeveloperSettings,
} from "../interfaces-and-types";

export const DeveloperSettingsContext = createContext<
  IRemoteDataContext<IViewDeveloperSettings | null>
>({
  // remote data
  isSuccess: false,
  isError: false,
  isLoading: false,
  data: null,
  refreshRemoteData: () => {},
});
